"use client";

import React from "react";
import { motion } from "framer-motion";
import Image from "next/image";

interface FlowingSOLALogoProps {
  size?: number;
  speed?: number;
}

export function FlowingSOLALogo({
  size = 64,
  speed = 3,
}: FlowingSOLALogoProps) {
  return (
    <div
      style={{
        position: "relative",
        width: size,
        height: size,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        borderRadius: "50%",
      }}
    >
      {/* Base SOLA logo */}
      <div
        style={{
          position: "relative",
          zIndex: 1,
          width: size,
          height: size,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Image
          src="/img/floats/sola.svg"
          alt="SOLA"
          width={size}
          height={size}
          priority
          style={{ display: "block" }}
        />
      </div>

      {/* Flowing gradient overlay */}
      <motion.div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 2,
          pointerEvents: "none",
          background:
            "conic-gradient(from 0deg, transparent 0%, rgba(151, 71, 255, 0.3) 25%, rgba(0, 50, 153, 0.3) 50%, rgba(15, 219, 204, 0.3) 75%, transparent 100%)",
          mixBlendMode: "overlay",
          borderRadius: "50%",
        }}
        animate={{
          rotate: [0, 360],
        }}
        transition={{
          duration: speed,
          repeat: Infinity,
          ease: "linear",
        }}
      />

      {/* Second flowing gradient for depth */}
      <motion.div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 3,
          pointerEvents: "none",
          background:
            "conic-gradient(from 180deg, transparent 0%, rgba(15, 219, 204, 0.2) 25%, rgba(151, 71, 255, 0.2) 50%, rgba(0, 50, 153, 0.2) 75%, transparent 100%)",
          mixBlendMode: "screen",
          borderRadius: "50%",
        }}
        animate={{
          rotate: [360, 0],
        }}
        transition={{
          duration: speed * 1.5,
          repeat: Infinity,
          ease: "linear",
        }}
      />

      {/* Shimmer effect */}
      <motion.div
        style={{
          position: "absolute",
          top: "-50%",
          left: "-50%",
          width: "200%",
          height: "200%",
          zIndex: 4,
          pointerEvents: "none",
          background:
            "linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.3) 50%, transparent 70%)",
        }}
        animate={{
          x: ["-100%", "100%"],
          y: ["-100%", "100%"],
        }}
        transition={{
          duration: speed * 2,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />
    </div>
  );
}
